import {Injectable} from '@angular/core';

@Injectable()
export class LeftMenu {
  biller: boolean;
  institutionalBiller: boolean;
  user: boolean;
  sms: boolean;
  bank: boolean;
  merchant: boolean;
  dashboard: boolean;
  bkashRefund: boolean;
  commission: boolean;
  syndicate: boolean;
  isGrs: boolean;
  challan: boolean;
  isEkpayCmsConfig;
  isReport: boolean;
  isDms: boolean;
  isAssistedDashboard: boolean;
  isWalletTransaction: boolean;
  isAdminDashboard: boolean;
  isCustomDashboard: boolean;
  isBillerDashboard: boolean;
  isBankDashboard: boolean;
  isGRSDashboard: boolean;
  isLogs: boolean;
  isEkpayCharge: boolean;
  isBannerConfig: boolean;
  isFeedback: boolean;
  isSettlement: boolean;
  reconcilliation: boolean;
  isReconcilliationDashboard: boolean;
  challanIntegration: boolean;
  commissionSetting: boolean;
  newReport: boolean;
  topUp: boolean;
  isAgent: boolean;

  agentManagement: boolean;
  topUpWallet: boolean;
  paymentHistory: boolean;
  commissionSettlement: boolean;
  isEkpayChargeConfiguration: boolean;
  isEkpayDiscountDetail: boolean;
  isAccountVerification: boolean;
  merchantAppearance: boolean;
  isEmi: boolean;

  constructor() {

  }

  initAll() {
    this.biller = false;
    this.user = false;
    this.sms = false;
    this.bank = false;
    this.merchant = false;
    this.dashboard = false;
    this.syndicate = false;
    this.isGrs = false;
    this.isReport = false;
    this.isDms = false;
    this.isAssistedDashboard = false;
    this.isWalletTransaction = false;
    this.isAdminDashboard = false;
    this.isCustomDashboard = false;
    this.isBillerDashboard = false;
    this.isBankDashboard = false;
    this.isGRSDashboard = false;
    this.isLogs = false;
    this.isEkpayCharge = false;
    this.isBannerConfig = false;
    this.isFeedback = false;
    this.reconcilliation = false;
    this.isReconcilliationDashboard = false;
    this.isReport = false;
    this.challan = false;
    this.isSettlement = false;
    this.isEkpayCmsConfig = false;
    this.bkashRefund = false;
    this.commission = false;
    this.challanIntegration = false;
    this.isAgent = false;
    this.agentManagement = false;
    this.topUpWallet = false;
    this.commissionSetting = false;
    this.commissionSettlement = false;
    this.paymentHistory = false;
    this.isEkpayChargeConfiguration = false;
    this.isEkpayDiscountDetail = false;
    this.isAccountVerification = false;
    this.merchantAppearance = false;
    this.newReport = false;
    this.topUp = false;
    this.isEmi = false;
    this.institutionalBiller = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/leftmenu/LeftMenu.ts